if (!customElements.get("remove-free-gift")) {
  class removeFreeProduct extends HTMLElement {
    constructor() {
      super();
      this.removeGiftProduct();
    }

    removeGiftProduct() {
      var cart = document.querySelector("m-cart") || document.querySelector("m-cart-drawer-items");
      var prodcutId = this.dataset.freeProductId;
      if (!cart || !prodcutId) return;
      var freeGiftProductInCart = cart.querySelector(`[data-product-id="${prodcutId}"] m-cart-remove-button`);

      if (!freeGiftProductInCart) return;
      // Remove gift product
      freeGiftProductInCart.click();
    }
  }
  customElements.define("remove-free-gift", removeFreeProduct);
}
